// Clinic costume v1 — doctors, dental, skin, physio, diagnostics.
// Engine stage KEYS never change; only the labels do.

export const CLINIC_COSTUME = {
  costumeId: "clinic_v1",

  stages: [
    { key: "new", label: "New" },
    { key: "spoke", label: "Spoke to them" },
    { key: "visit_scheduled", label: "Appointment booked" },
    { key: "visited", label: "Consulted" },
    { key: "sent_price", label: "Sent estimate" },
    { key: "signed_up", label: "Treatment started" },
    { key: "lost", label: "Lost" },
  ],

  stageColors: {
    new: "bg-amber-100 text-amber-800 border-amber-200",
    spoke: "bg-orange-100 text-orange-800 border-orange-200",
    visit_scheduled: "bg-yellow-100 text-yellow-800 border-yellow-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sent_price: "bg-rose-100 text-rose-800 border-rose-200",
    signed_up: "bg-green-100 text-green-800 border-green-200",
    lost: "bg-zinc-200 text-zinc-700 border-zinc-300",
  },

  defaultSources: [
    "Walk-in",
    "Phone call",
    "Google maps",
    "Practo / JustDial",
    "Referral",
    "Social media",
    "Others",
  ],

  lostReasons: [
    "Cost too high",
    "Chose another clinic",
    "Distance / location",
    "Postponed treatment",
    "Just enquiring",
    "Stopped responding",
    "Other",
  ],

  enquiryTypes: [
    "General consultation",
    "Dental",
    "Skin / Hair",
    "Physiotherapy",
    "Diagnostics / Tests",
    "Surgery / Procedure",
    "Follow-up visit",
  ],

  waTemplates: [
    { name: "First contact", body: "Hi {{name}}, this is {{me}} from {{company}}. Thanks for reaching out — how can we help? Happy to book you a convenient slot." },
    { name: "Appointment invite", body: "Hi {{name}}, shall I book your appointment? Tell me a day and time that works and I'll confirm right away." },
    { name: "Estimate share", body: "Hi {{name}}, sharing the treatment estimate as discussed: {{quote}}. Feel free to call me if you have any questions." },
    { name: "Soft follow-up", body: "Hi {{name}}, just checking in — would you like to go ahead and book a slot?" },
    { name: "Polite drop", body: "Hi {{name}}, hope you're doing well. Closing this for now; whenever you'd like to come in, just message me." },
  ],

  companyInfo: { name: "", me: "", address: "" },

  vocab: {
    unit: "visit",
    units: "visits",
    location: "branch",
    locations: "branches",
    customer: "patient",
  },

  copy: {
    appName: "Jigyasa",
    sectionTrend: "Enquiries vs treatments started — last 6 months",
    sectionAttention: "Needs your attention",
    attentionAllClear: "All caught up — nothing is waiting on you.",
    attentionWaitingQuote: "waiting after estimate",
    remarksTitle: "Remarks & history",
    remarkPlaceholder: "e.g. Will confirm appointment after talking to family",
    addRemarkButton: "Add",
    remarksEmpty: "No remarks yet — add one after each call so the story stays in one place.",
    settingsSourcesTitle: "Manage enquiry sources",
    settingsSourcesNote: "Each organisation sets up its own list of where enquiries come from. Removing a source never changes past enquiries — it only affects new ones.",
    pastEnquiryBannerLabel: "Returning enquiry",
    pastEnquiryBannerNote: "We've spoken before — don't start cold.",
    footprintBannerLabel: "Already with us",
    footprintInlineDismiss: "This is someone new — clear and start fresh",
  },

  buttonsOn: {
    liveStock: false,
    upcomingStock: false,
    customerFootprint: false,
    pastEnquiries: true,
    pricingAndOffers: false,
    activityHistory: false,
    renewalPipeline: false,
    locationCatalog: false,
    satisfaction: false,
    availability: false,
    compliance: false,
    communications: false,
  },
};
